import { useMemo } from 'react';

import { sanitizeRichTextHtml } from '../security/sanitizeHtml';

interface RichTextViewerProps {
  content: string;
  className?: string;
}

export default function RichTextViewer({ content, className = '' }: RichTextViewerProps) {
  if (!content || content === '<p></p>') {
    return (
      <div className={`text-gray-500 italic ${className}`}>
        No content available.
      </div>
    );
  }

  const sanitizedContent = useMemo(() => sanitizeRichTextHtml(content), [content]);

  return (
    <div
      className={`guide-content prose prose-slate max-w-none
        prose-headings:font-semibold prose-headings:tracking-tight
        prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4 prose-h2:pb-2 prose-h2:border-b prose-h2:border-gray-200
        prose-h3:text-xl prose-h3:mt-6 prose-h3:mb-3
        prose-p:text-gray-700 prose-p:leading-relaxed
        prose-li:text-gray-700 prose-li:leading-relaxed
        prose-a:text-primary-600 prose-a:no-underline hover:prose-a:underline
        prose-blockquote:border-l-4 prose-blockquote:border-primary-400 prose-blockquote:bg-primary-50 prose-blockquote:py-2 prose-blockquote:px-4 prose-blockquote:rounded-r-lg prose-blockquote:not-italic prose-blockquote:text-gray-700
        prose-strong:text-gray-900
        prose-hr:my-8
        prose-img:rounded-lg prose-img:shadow-sm prose-img:my-6 prose-img:max-w-full prose-img:h-auto
        ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
}
